import React, { Component } from 'react';
import { Row, Col, Modal, Icon, Tooltip, Progress, message, List, Button } from "antd";
import axios from "axios";
import { Link } from "react-router-dom";
import moment from "moment-timezone";
import numeral from "numeral";
import { getUsuarioToken, getTemPermissao, removeToken } from "../utils/LoginManager";
import Colors from '../utils/Colors';
import LogoP7Vendas from '../imagens/p7.png';
import FiltrosDashBoardForm from '../components/FiltrosDashBoardForm';
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip as TooltipChart, Legend, PieChart, Pie, Sector, Cell } from "recharts";

const CORES = ["#8884d8", "#82ca9d", "#FFBB28", "#FF8042", "#AF19FF", '#0088FE', '#00C49F', '#FFBB28'];

const RADIAN = Math.PI / 180;
const renderCustomizedLabel = ({ cx, cy, midAngle, innerRadius, outerRadius, percent, index }) => {
    const radius = innerRadius + (outerRadius - innerRadius) * 0.5;
    const x = cx + radius * Math.cos(-midAngle * RADIAN);
    const y = cy + radius * Math.sin(-midAngle * RADIAN);

    return (
        <text x={x} y={y} fill={Colors.primaryDark} textAnchor={x > cx ? 'start' : 'end'} dominantBaseline="central">
            {`${(percent * 100).toFixed(0)}%`}
        </text>
    );
};

export default class extends Component {

    state = {
        par_ult_importacao: '',
        par_bloquear_sinc_pedidos: 0,
        sincParado: 0,

        mesAtual: '',
        anoAtual: '',
        mesAtualDescricao: '',

        qtdeProdutos: 0,
        qtdeClientes: 0,
        qtdeVendedores: 0,

        vlrVendasHoje: 0,
        qtdeVendasHoje: 0,

        vlrVendasMes: 0,
        qtdeVendasMes: 0,

        vlrVendasAno: 0,
        qtdeVendasAno: 0,

        qtdeSincronizados: 0,
        qtdeMetasVen: 0,
        qtdeMetasEmp: 0,
        qtdeEntregas: 0,
        qtdeAtividades: 0,


        listaClientes: [],
        listaProdutos: [],
        listaGrupos: [],
        listaStatusPedidos: [],
        listaEntregas: [],
        listaVendasCarteiraClientes: [],

        activeIndex: 0,
        mostraDashBoard: false,

        formFiltroVisivel: false,

        filtroProps: {},

        filtros: {
            tipoTela: '',
            vendasDiaIni: moment(new Date()).format('DD/MM/YYYY'),
            vendasDiaFim: moment(new Date()).format('DD/MM/YYYY'),
            vendasMes: moment(new Date()).format('MM/YYYY'),
            vendasAno: moment(new Date()).format('YYYY'),

            graficoVendasMeses: moment(new Date()).format('YYYY'),
            graficoMetasMeses: moment(new Date()).format('YYYY'),

            listaMelhoresClienteDataIni: moment(new Date()).subtract(30, 'days').format('DD/MM/YYYY'),
            listaMelhoresClienteDataFim: moment(new Date()).format('DD/MM/YYYY'),

            listaProdutosVendidoDataIni: moment(new Date()).subtract(30, 'days').format('DD/MM/YYYY'),
            listaProdutosVendidoDataFim: moment(new Date()).format('DD/MM/YYYY'),

            listaVendasGrupoDataIni: moment(new Date()).subtract(30, 'days').format('DD/MM/YYYY'),
            listaVendasGrupoDataFim: moment(new Date()).format('DD/MM/YYYY'),

            vendasCarteiraIni: moment(new Date()).subtract(30, 'days').format('DD/MM/YYYY'),
            vendasCarteiraFim: moment(new Date()).format('DD/MM/YYYY'),

            buscaPessoa: { key: '0', },
            buscaUsuario: { key: '0', },
            buscaProduto: { key: '0' },
            buscaGrupoProduto: { key: '0' },
            buscaStatus: { key: '' },
        }

    }

    componentDidMount() {
        this.verificaSessaoAtiva();
        const usuario = getUsuarioToken();
        this.setState({
            usuario,
            mostraDashBoard: getTemPermissao('HomeDashBoardPage', 'cons'),
        }, this.atualizarDashboard(this.state.filtros));
    }


    verificaSessaoAtiva = () => {
        setTimeout(() => {
            axios
                .post('/usuarios/validaSessionLogin')
                .then(response => {
                    if (response.data) {
                        Modal.info({ title: 'Atenção!', content: 'Usuário desconectado. A quantidade de usuários conectados excedeu seu limite' });
                        removeToken();
                        this.props.history.push("/login");
                    }
                })
                .catch(error => {
                    console.error(error.response);
                    this.setState({
                        carregando: false,
                    });
                });

            this.verificaSessaoAtiva();
        }, 120000);
    }


    onAbrirFiltroClick = (tipoFiltro) => {
        // console.log('onAbrirFiltroClick: ', tipoFiltro)
        // console.log('onAbrirFiltroClick: ', this.state.filtros)

        let dataIni = '';
        let dataFim = '';
        let mes = '';
        let ano = '';
        let pessoa = '';
        let usuario = '';
        let produto = '';
        let grupo = '';

        if (tipoFiltro === 'VD') {
            dataIni = this.state.filtros.vendasDiaIni;
            dataFim = this.state.filtros.vendasDiaFim;
        } else if (tipoFiltro === 'VM') {
            mes = moment(this.state.filtros.vendasMes, 'MM/YYYY').format('MM');
            ano = moment(this.state.filtros.vendasMes, 'MM/YYYY').format('YYYY');
        } else if (tipoFiltro === 'VA') {
            ano = this.state.filtros.vendasAno;
        } else if (tipoFiltro === 'GVM') {
            ano = this.state.filtros.graficoVendasMeses;
        } else if (tipoFiltro === 'GMM') {
            ano = this.state.filtros.graficoMetasMeses;
        } else if (tipoFiltro === 'GVC') {
            dataIni = this.state.filtros.vendasCarteiraIni;
            dataFim = this.state.filtros.vendasCarteiraFim;
        } else if (tipoFiltro === 'LMC') {
            dataIni = this.state.filtros.listaMelhoresClienteDataIni;
            dataFim = this.state.filtros.listaMelhoresClienteDataFim;
        } else if (tipoFiltro === 'LPV') {
            dataIni = this.state.filtros.listaProdutosVendidoDataIni;
            dataFim = this.state.filtros.listaProdutosVendidoDataFim;
        } else if (tipoFiltro === 'LGP') {
            dataIni = this.state.filtros.listaVendasGrupoDataIni;
            dataFim = this.state.filtros.listaVendasGrupoDataFim;
        }

        // console.log('onAbrirFiltroClick: ', this.state.filtros.buscaPessoa)

        this.setState({
            formFiltroVisivel: true,
            filtroProps: {
                tipoTela: tipoFiltro,
                buscaDataIni: dataIni,
                buscaDataFim: dataFim,
                buscaMes: mes,
                buscaAno: ano,
                buscaPessoa: this.state.filtros.buscaPessoa,
                buscaUsuario: this.state.filtros.buscaUsuario,
                buscaProduto: produto,
                buscaGrupoProduto: grupo,
                buscaStatus: this.state.filtros.buscaStatus,
            }
        })
    };

    onFiltrarClick = (filtrosProps) => {
        // console.log('onFiltrarClick props: ', filtrosProps);
        // console.log('onFiltrarClick state: ', this.state.filtros)

        let vendasDiaIni = this.state.filtros.vendasDiaIni;
        let vendasDiaFim = this.state.filtros.vendasDiaFim;
        let vendasMes = this.state.filtros.vendasMes;
        let vendasAno = this.state.filtros.vendasAno;
        let graficoVendasMeses = this.state.filtros.graficoVendasMeses;
        let graficoMetasMeses = this.state.filtros.graficoMetasMeses;
        let vendasCarteiraIni = this.state.filtros.vendasCarteiraIni;
        let vendasCarteiraFim = this.state.filtros.vendasCarteiraIni;
        let listaMelhoresClienteDataIni = this.state.filtros.listaMelhoresClienteDataIni;
        let listaMelhoresClienteDataFim = this.state.filtros.listaMelhoresClienteDataFim;
        let listaProdutosVendidoDataIni = this.state.filtros.listaProdutosVendidoDataIni;
        let listaProdutosVendidoDataFim = this.state.filtros.listaProdutosVendidoDataFim;
        let listaVendasGrupoDataIni = this.state.filtros.listaVendasGrupoDataIni;
        let listaVendasGrupoDataFim = this.state.filtros.listaVendasGrupoDataFim;

        if (filtrosProps.tipoTela === 'VD') {
            vendasDiaIni = filtrosProps.buscaDataIni;
            vendasDiaFim = filtrosProps.buscaDataFim;
        } else if (filtrosProps.tipoTela === 'VM') {
            vendasMes = filtrosProps.buscaMes + '/' + filtrosProps.buscaAno;
        } else if (filtrosProps.tipoTela === 'VA') {
            vendasAno = filtrosProps.buscaAno;
        } else if (filtrosProps.tipoTela === 'GVM') {
            graficoVendasMeses = filtrosProps.buscaAno;
        } else if (filtrosProps.tipoTela === 'GMM') {
            graficoMetasMeses = filtrosProps.buscaAno;
        } else if (filtrosProps.tipoTela === 'GVC') {
            vendasCarteiraIni = filtrosProps.buscaDataIni;
            vendasCarteiraFim = filtrosProps.buscaDataFim;
        } else if (filtrosProps.tipoTela === 'LMC') {
            listaMelhoresClienteDataIni = filtrosProps.buscaDataIni;
            listaMelhoresClienteDataFim = filtrosProps.buscaDataFim;
        } else if (filtrosProps.tipoTela === 'LPV') {
            listaProdutosVendidoDataIni = filtrosProps.buscaDataIni;
            listaProdutosVendidoDataFim = filtrosProps.buscaDataFim;
        } else if (filtrosProps.tipoTela === 'LGP') {
            listaVendasGrupoDataIni = filtrosProps.buscaDataIni;
            listaVendasGrupoDataFim = filtrosProps.buscaDataFim;
        }

        const filtros = {
            tipoTela: filtrosProps.tipoTela,

            vendasDiaIni,
            vendasDiaFim,
            vendasMes,
            vendasAno,

            graficoVendasMeses,
            graficoMetasMeses,

            vendasCarteiraIni,
            vendasCarteiraFim,

            listaMelhoresClienteDataIni,
            listaMelhoresClienteDataFim,

            listaProdutosVendidoDataIni,
            listaProdutosVendidoDataFim,

            listaVendasGrupoDataIni,
            listaVendasGrupoDataFim,

            buscaPessoa: filtrosProps.buscaPessoa,
            buscaUsuario: filtrosProps.buscaUsuario,
            buscaProduto: filtrosProps.buscaProduto,
            buscaGrupoProduto: filtrosProps.buscaGrupoProduto,
            buscaStatus: filtrosProps.buscaStatus,
        }

        // console.log('onFiltrarClick: ', filtros);

        this.setState({
            formFiltroVisivel: false,
            filtros,
        },
            this.atualizarDashboard(filtros)
        )
    };

    onCancelarFiltroClick = () => {
        this.setState({
            formFiltroVisivel: false,
        })
    };




    atualizarDashboard = (filtros) => {
        this.setState({ qtdeColab: "0", qtdePedidos: "0", qtdeProdutos: "0", qtdePedidosSincronizar: "0" });

        // console.log('atualizarDashboard - filtros: ', filtros);

        axios
            .get('/vendas/dashboard', {
                params: {
                    vendasDiaIni: moment(filtros.vendasDiaIni, 'DD/MM/YYYY').format('YYYY-MM-DD'),
                    vendasDiaFim: moment(filtros.vendasDiaFim, 'DD/MM/YYYY').format('YYYY-MM-DD'),
                    vendasMes: moment(filtros.vendasMes, 'MM/YYYY').format('YYYY-MM'),
                    vendasAno: filtros.vendasAno,

                    graficoVendasMeses: filtros.graficoVendasMeses,
                    graficoMetasMeses: filtros.graficoMetasMeses,

                    vendasCarteiraIni: moment(filtros.vendasCarteiraIni, 'DD/MM/YYYY').format('YYYY-MM-DD'),
                    vendasCarteiraFim: moment(filtros.vendasCarteiraFim, 'DD/MM/YYYY').format('YYYY-MM-DD'),

                    listaMelhoresClienteDataIni: moment(filtros.listaMelhoresClienteDataIni, 'DD/MM/YYYY').format('YYYY-MM-DD'),
                    listaMelhoresClienteDataFim: moment(filtros.listaMelhoresClienteDataFim, 'DD/MM/YYYY').format('YYYY-MM-DD'),

                    listaProdutosVendidoDataIni: moment(filtros.listaProdutosVendidoDataIni, 'DD/MM/YYYY').format('YYYY-MM-DD'),
                    listaProdutosVendidoDataFim: moment(filtros.listaProdutosVendidoDataFim, 'DD/MM/YYYY').format('YYYY-MM-DD'),

                    listaVendasGrupoDataIni: moment(filtros.listaVendasGrupoDataIni, 'DD/MM/YYYY').format('YYYY-MM-DD'),
                    listaVendasGrupoDataFim: moment(filtros.listaVendasGrupoDataFim, 'DD/MM/YYYY').format('YYYY-MM-DD'),

                    vendasPessoa: filtros.buscaPessoa.key,
                    vendasUsuario: filtros.buscaUsuario.key,
                    vendasStatus: filtros.buscaStatus.key,
                    // buscaProduto: filtros.buscaProduto.key,
                    // buscaGrupoProduto: filtros.buscaGrupoProduto.key,
                }
            })
            .then(response => {
                const { data } = response;

                // console.log('atualizarDashboard: ', data);

                this.setState({

                    par_ult_importacao: data.par_ult_importacao,
                    par_bloquear_sinc_pedidos: data.par_bloquear_sinc_pedidos,
                    // sincParado: data.sincParado,
                    anoAtual: data.anoAtual,
                    mesAtualDescricao: moment(data.anoAtual + '-' + data.mesAtual + '-01').format("MMM") + '/' + data.anoAtual,

                    qtdeProdutos: data.qtdeProdutos,
                    qtdeClientes: data.qtdeClientes,
                    qtdeVendedores: data.qtdeVendedores,

                    vlrVendasHoje: data.vlrVendasHoje,
                    qtdeVendasHoje: data.qtdeVendasHoje,

                    vlrVendasMes: data.vlrVendasMes,
                    qtdeVendasMes: data.qtdeVendasMes,

                    vlrVendasAno: data.vlrVendasAno,
                    qtdeVendasAno: data.qtdeVendasAno,

                    qtdeSincronizados: data.qtdeSincronizados ? data.qtdeSincronizados.toFixed(2) : 0,
                    qtdeMetasVen: data.qtdeMetasVen ? data.qtdeMetasVen.toFixed(2) : 0,
                    qtdeMetasEmp: data.qtdeMetasEmp ? data.qtdeMetasEmp.toFixed(2) : 0,
                    qtdeEntregas: data.qtdeEntregas ? data.qtdeEntregas.toFixed(2) : 0,
                    qtdeAtividades: data.qtdeAtividades ? data.qtdeAtividades.toFixed(2) : 0,

                    listaClientes: data.listaClientes,
                    listaProdutos: data.listaProdutos,
                    listaGrupos: data.listaGrupos,

                    listaVendasMeses: data.listaVendasMeses,
                    listaVendasAnos: data.listaVendasAnos,

                    listaMetasMeses: data.listaMetasMeses,
                    listaMetasAnos: data.listaMetasAnos,

                    listaStatusPedidos: data.listaStatusPedidos,
                    listaEntregas: data.listaEntregas,
                    listaVendasCarteiraClientes: data.listaVendasCarteiraClientes,

                })
            })
            .catch(error => {
                console.error(error.response);
                this.setState({
                    carregando: false,
                });
            });
    };

    renderValor = (vlr) => {
        return (
            <span> {numeral(parseFloat(vlr)).format('0,000.00')} </span>
        );
    };



    onBloqueioSinc = () => {
        if (!this.state.usuario.usu_tipo) {
            const par_bloquear_sinc_pedidos = this.state.par_bloquear_sinc_pedidos ? 0 : 1;

            // console.log('onBloqueioSinc: ', par_bloquear_sinc_pedidos)

            this.setState({ carregando: true })
            axios.put(`/usuarios/bloqueioSinc/${0}/${par_bloquear_sinc_pedidos}`)
                .then(response => {
                    message.success('Parâmetro Alterado');
                    this.setState({
                        par_bloquear_sinc_pedidos,
                        carregando: false
                    })
                }).catch(error => {
                    console.error(error.response);
                    this.setState({ carregando: false })
                })
        }
    };

    onMudaDashBoardPress = () => {
        this.setState({
            mostraDashBoard: !this.state.mostraDashBoard
        })
    }





    render() {
        const {
            usuario, par_ult_importacao, par_bloquear_sinc_pedidos, sincParado, qtdeProdutos, qtdeClientes, qtdeVendedores,
            vlrVendasHoje, qtdeVendasHoje, vlrVendasMes, qtdeVendasMes, vlrVendasAno, qtdeVendasAno,
            anoAtual, mesAtualDescricao, qtdeSincronizados, qtdeMetasVen, qtdeMetasEmp, qtdeAtividades, qtdeEntregas,
            listaClientes, listaProdutos, listaGrupos, listaVendasMeses, listaVendasAnos, listaMetasMeses, listaMetasAnos, listaStatusPedidos, listaEntregas, listaVendasCarteiraClientes,
            mostraDashBoard, formFiltroVisivel, filtros, filtroProps
        } = this.state;

        // console.log('HomePage.this.state: ', this.state);
        // console.log('HomePage.this.filtros: ', filtros);
        // console.log('HomePage.this.state: ', data);
        // console.log('HomePage.this.state: ', window.innerWidth);

        return (
            <div>

                <FiltrosDashBoardForm
                    visivel={formFiltroVisivel}
                    onFiltrarClick={this.onFiltrarClick}
                    onCancelarFiltroClick={this.onCancelarFiltroClick}
                    filtros={filtroProps}
                />

                {mostraDashBoard ? (
                    <Row>
                        <Row>
                            <Col xs={24} md={18} style={{ height: 300 }}>
                                <Row>
                                    <Col xs={24} md={8} style={{ height: 150, padding: 5 }}>
                                        <div style={{ height: "100%", borderStyle: "outset", borderWidth: 2, borderRadius: 5, backgroundColor: "white" }}>
                                            <Row style={{ textAlign: "center", marginTop: 5, marginBottom: 5 }}>
                                                <span style={{ fontSize: 20, fontWeight: "bold", color: Colors.primary }}>
                                                    Vendas / Dia
                                                </span>
                                                <Tooltip title="Filtrar" placement="bottomLeft">
                                                    <span onClick={() => this.onAbrirFiltroClick('VD')} style={{ cursor: 'pointer', fontSize: 20, float: 'right', paddingRight: 20 }} >
                                                        <Icon type="filter" />
                                                    </span>
                                                </Tooltip>
                                                <Row style={{ fontSize: 12, textAlign: 'left', paddingLeft: 20 }}>{this.state.filtros.vendasDiaIni + ' a ' + this.state.filtros.vendasDiaFim}</Row>
                                            </Row>
                                            <Row style={{ textAlign: "right", marginRight: 20, marginTop: -20 }}>
                                                <Row>
                                                    <span style={{ fontSize: 13, fontWeight: "bold", color: Colors.primaryLight }}>Vendas Realizadas</span>
                                                </Row>
                                                <Row style={{ marginTop: -5 }}>
                                                    <span style={{ fontSize: 18, fontWeight: "bold", color: "rgba(0, 0, 0, 0.45)" }}>{qtdeVendasHoje}</span>
                                                </Row>
                                            </Row>
                                            <Row style={{ textAlign: "right", marginRight: 20 }}>
                                                <Row>
                                                    <span style={{ fontSize: 13, fontWeight: "bold", color: Colors.primaryLight }}>Valor Total</span>
                                                </Row>
                                                <Row style={{ marginTop: -5 }}>
                                                    <span style={{ fontSize: 18, fontWeight: "bold", color: "rgba(0, 0, 0, 0.45)" }}>R$ {this.renderValor(vlrVendasHoje)}</span>
                                                </Row>
                                            </Row>
                                        </div>
                                    </Col>
                                    <Col xs={24} md={8} style={{ height: 150, padding: 5 }}>
                                        <div style={{ height: "100%", borderStyle: "outset", borderWidth: 2, borderRadius: 5, backgroundColor: "white" }}>
                                            <Row style={{ textAlign: "center", marginTop: 5, marginBottom: 5 }}>
                                                <span style={{ fontSize: 20, fontWeight: "bold", color: Colors.primary }}>
                                                    Vendas {moment(filtros.vendasMes, 'MM/YYYY').format('MMM/YYYY')}
                                                </span>
                                                <Tooltip title="Filtrar" placement="bottomLeft">
                                                    <span onClick={() => this.onAbrirFiltroClick('VM')} style={{ cursor: 'pointer', fontSize: 20, float: 'right', paddingRight: 20 }} >
                                                        <Icon type="filter" />
                                                    </span>
                                                </Tooltip>
                                            </Row>
                                            <Row style={{ textAlign: "right", marginRight: 20 }}>
                                                <Row>
                                                    <span style={{ fontSize: 13, fontWeight: "bold", color: Colors.primaryLight }}>Vendas Realizadas</span>
                                                </Row>
                                                <Row style={{ marginTop: -5 }}>
                                                    <span style={{ fontSize: 18, fontWeight: "bold", color: "rgba(0, 0, 0, 0.45)" }}>{qtdeVendasMes}</span>
                                                </Row>
                                            </Row>
                                            <Row style={{ textAlign: "right", marginRight: 20 }}>
                                                <Row>
                                                    <span style={{ fontSize: 13, fontWeight: "bold", color: Colors.primaryLight }}>Valor Total</span>
                                                </Row>
                                                <Row style={{ marginTop: -5 }}>
                                                    <span style={{ fontSize: 18, fontWeight: "bold", color: "rgba(0, 0, 0, 0.45)" }}>R$ {this.renderValor(vlrVendasMes)}</span>
                                                </Row>
                                            </Row>
                                        </div>
                                    </Col>
                                    <Col xs={24} md={8} style={{ height: 150, padding: 5 }}>
                                        <div style={{ height: "100%", borderStyle: "outset", borderWidth: 2, borderRadius: 5, backgroundColor: "white" }}>
                                            <Row style={{ textAlign: "center", marginTop: 5, marginBottom: 5 }}>
                                                <span style={{ fontSize: 20, fontWeight: "bold", color: Colors.primary }}>
                                                    Vendas Ano {filtros.vendasAno}
                                                </span>
                                                <Tooltip title="Filtrar" placement="bottomLeft">
                                                    <span onClick={() => this.onAbrirFiltroClick('VA')} style={{ cursor: 'pointer', fontSize: 20, float: 'right', paddingRight: 20 }} >
                                                        <Icon type="filter" />
                                                    </span>
                                                </Tooltip>
                                            </Row>
                                            <Row style={{ textAlign: "right", marginRight: 20 }}>
                                                <Row>
                                                    <span style={{ fontSize: 13, fontWeight: "bold", color: Colors.primaryLight }}>Vendas Realizadas</span>
                                                </Row>
                                                <Row style={{ marginTop: -5 }}>
                                                    <span style={{ fontSize: 18, fontWeight: "bold", color: "rgba(0, 0, 0, 0.45)" }}>{qtdeVendasAno}</span>
                                                </Row>
                                            </Row>
                                            <Row style={{ textAlign: "right", marginRight: 20 }}>
                                                <Row>
                                                    <span style={{ fontSize: 13, fontWeight: "bold", color: Colors.primaryLight }}>Valor Total</span>
                                                </Row>
                                                <Row style={{ marginTop: -5 }}>
                                                    <span style={{ fontSize: 18, fontWeight: "bold", color: "rgba(0, 0, 0, 0.45)" }}>R$ {this.renderValor(vlrVendasAno)}</span>
                                                </Row>
                                            </Row>
                                        </div>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col xs={24} md={8} style={{ height: 150, padding: 5 }}>
                                        <Tooltip title={"Pedidos Sincronizados X Não Sincronizados (Últimos 30 dias)"}>
                                            <div style={{ height: "100%", borderStyle: "outset", borderWidth: 2, borderRadius: 5, backgroundColor: "white" }}>
                                                <Row style={{ textAlign: "center", marginTop: 5, marginBottom: 5 }}>
                                                    <span style={{ fontSize: 20, fontWeight: "bold", color: Colors.primary }}>
                                                        Sincronizados
                                                    </span>
                                                </Row>
                                                <Row style={{ textAlign: 'center' }}>
                                                    <Progress type="dashboard" percent={parseFloat(qtdeSincronizados)} width={80} />
                                                </Row>
                                            </div>
                                        </Tooltip>
                                    </Col>
                                    <Col xs={24} md={8} style={{ height: 150, padding: 5 }}>
                                        <Tooltip title={"Pedidos Entregues (Últimos 30 dias)"}>
                                            <div style={{ height: "100%", borderStyle: "outset", borderWidth: 2, borderRadius: 5, backgroundColor: "white" }}>
                                                <Row style={{ textAlign: "center", marginTop: 5, marginBottom: 5 }}>
                                                    <span style={{ fontSize: 20, fontWeight: "bold", color: Colors.primary }}>
                                                        Entregas
                                                    </span>
                                                </Row>
                                                <Row style={{ textAlign: 'center' }}>
                                                    <Progress type="dashboard" percent={parseFloat(qtdeEntregas)} width={80} />
                                                </Row>
                                            </div>
                                        </Tooltip>
                                    </Col>
                                    {/* <Col xs={24} md={6} style={{ height: 150, padding: 5 }}>
                                        <Tooltip title={"Metas Atingidas do Vendedor (Meta Anual)"}>
                                            <div style={{ height: "100%", borderStyle: "outset", borderWidth: 2, borderRadius: 5, backgroundColor: "white" }}>
                                                <Row style={{ textAlign: "center", marginTop: 5, marginBottom: 5 }}>
                                                    <span style={{ fontSize: 20, fontWeight: "bold", color: Colors.primary }}>
                                                        Metas Vendedor
                                                    </span>
                                                </Row>
                                                <Row style={{ textAlign: 'center' }}>
                                                    <Progress type="dashboard" percent={parseFloat(qtdeMetasVen)} width={80} />
                                                </Row>
                                            </div>
                                        </Tooltip>
                                    </Col>
                                    <Col xs={24} md={6} style={{ height: 150, padding: 5 }}>
                                        <Tooltip title={"Metas Atingidas da Empresa (Meta Anual)"}>
                                            <div style={{ height: "100%", borderStyle: "outset", borderWidth: 2, borderRadius: 5, backgroundColor: "white" }}>
                                                <Row style={{ textAlign: "center", marginTop: 5, marginBottom: 5 }}>
                                                    <span style={{ fontSize: 20, fontWeight: "bold", color: Colors.primary }}>
                                                        Metas Empresa
                                                    </span>
                                                </Row>
                                                <Row style={{ textAlign: 'center' }}>
                                                    <Progress type="dashboard" percent={parseFloat(qtdeMetasEmp)} width={80} />
                                                </Row>
                                            </div>
                                        </Tooltip>
                                    </Col> */}
                                    <Col xs={24} md={8} style={{ height: 150, padding: 5 }}>
                                        <Tooltip title={"Ativiadades Finalizadas X Não Finalizadas (Últimos 30 dias)"}>
                                            <div style={{ height: "100%", borderStyle: "outset", borderWidth: 2, borderRadius: 5, backgroundColor: "white" }}>
                                                <Row style={{ textAlign: "center", marginTop: 5, marginBottom: 5 }}>
                                                    <span style={{ fontSize: 20, fontWeight: "bold", color: Colors.primary }}>
                                                        Atividades
                                                    </span>
                                                </Row>
                                                <Row style={{ textAlign: 'center' }}>
                                                    <Progress type="dashboard" percent={parseFloat(qtdeAtividades)} width={80} />
                                                </Row>
                                            </div>
                                        </Tooltip>
                                    </Col>
                                </Row>
                            </Col>
                            <Col xs={24} md={6} style={{ height: 300, padding: 5 }}>
                                <div style={{ height: "100%", borderStyle: "outset", borderWidth: 2, borderRadius: 5, backgroundColor: "white" }}>
                                    <Row style={{ textAlign: "center", marginTop: 5, marginBottom: 5 }}>
                                        <span style={{ fontSize: 20, fontWeight: "bold", color: Colors.primary }}>
                                            Painel Administrativo
                                        </span>
                                    </Row>
                                    <Row style={{ textAlign: "right", marginRight: 20 }}>
                                        <Tooltip title={usuario && !usuario.usu_tipo ? (par_bloquear_sinc_pedidos ? "Ativar Sincronizador dos Pedidos" : "Desativar Sincronizador dos Pedidos") : ""}>
                                            <a onClick={() => this.onBloqueioSinc()}>
                                                <Row>
                                                    <span style={{ fontSize: 13, fontWeight: "bold", color: Colors.primaryLight }}>Sincronizador</span>
                                                </Row>
                                            </a>
                                        </Tooltip>
                                        <Row style={{ marginTop: -5 }}>
                                            <span style={{ fontSize: 18, fontWeight: "bold", color: par_bloquear_sinc_pedidos ? "red" : "rgba(0, 0, 0, 0.45)" }}>
                                                {par_bloquear_sinc_pedidos === 1 ? 'DESATIVADO' : 'ATIVADO'}
                                            </span>
                                        </Row>
                                    </Row>
                                    <Row style={{ textAlign: "right", marginRight: 20 }}>
                                        <Row>
                                            <span style={{ fontSize: 13, fontWeight: "bold", color: Colors.primaryLight }}>Última Importação</span>
                                        </Row>
                                        <Row style={{ marginTop: -5 }}>
                                            <span style={{ fontSize: 18, fontWeight: "bold", color: "rgba(0, 0, 0, 0.45)" }}>
                                                {moment(par_ult_importacao).format('DD/MM/YYYY HH:mm')}
                                            </span>
                                        </Row>
                                    </Row>
                                    <Row style={{ textAlign: "right", marginRight: 20 }}>
                                        <Row>
                                            <Tooltip title={filtros.buscaPessoa && filtros.buscaPessoa.key === '0' ? 'Filtrar Cliente' : filtros.buscaPessoa.label} placement="bottomLeft">
                                                <span onClick={() => this.onAbrirFiltroClick('PES')} style={{ cursor: 'pointer', fontSize: 20 }} >
                                                    <Icon type="filter" />
                                                </span>
                                            </Tooltip>
                                            <span style={{ fontSize: 13, fontWeight: "bold", color: Colors.primaryLight }}>Clientes</span>
                                        </Row>
                                        <Row style={{ marginTop: -5 }}>
                                            <span style={{ fontSize: 18, fontWeight: "bold", color: "rgba(0, 0, 0, 0.45)" }}>
                                                {qtdeClientes}
                                            </span>
                                        </Row>
                                    </Row>
                                    <Row style={{ textAlign: "right", marginRight: 20 }}>
                                        <Row>
                                            <Tooltip title={filtros.buscaUsuario && filtros.buscaUsuario.key === '0' ? 'Filtrar Vendedor' : filtros.buscaUsuario.label} placement="bottomLeft">
                                                <span onClick={() => this.onAbrirFiltroClick('USU')} style={{ cursor: 'pointer', fontSize: 20 }} >
                                                    <Icon type="filter" />
                                                </span>
                                            </Tooltip>
                                            <span style={{ fontSize: 13, fontWeight: "bold", color: Colors.primaryLight }}>Vendedores</span>
                                        </Row>
                                        <Row style={{ marginTop: -5 }}>
                                            <span style={{ fontSize: 18, fontWeight: "bold", color: "rgba(0, 0, 0, 0.45)" }}>
                                                {qtdeVendedores}
                                            </span>
                                        </Row>
                                    </Row>
                                    <Row style={{ textAlign: "right", marginRight: 20 }}>
                                        <Row>
                                            <span style={{ fontSize: 13, fontWeight: "bold", color: Colors.primaryLight }}>Produtos</span>
                                        </Row>
                                        <Row style={{ marginTop: -5 }}>
                                            <span style={{ fontSize: 18, fontWeight: "bold", color: "rgba(0, 0, 0, 0.45)" }}>
                                                {qtdeProdutos}
                                            </span>
                                        </Row>
                                    </Row>
                                </div>
                            </Col>
                        </Row>

                        <Row>
                            <Col xs={24} md={12} style={{ height: 300, padding: 5 }}>
                                <div style={{ height: "100%", borderStyle: "outset", borderWidth: 2, borderRadius: 5, backgroundColor: "white" }}>
                                    <Row style={{ textAlign: "center", marginTop: 5, marginBottom: 5 }}>
                                        <span style={{ fontSize: 20, fontWeight: "bold", color: Colors.primary }}>
                                            Vendas / Ano
                                        </span>
                                    </Row>
                                    <Row >
                                        <BarChart
                                            width={window.innerWidth / 2.3}
                                            height={250}
                                            data={listaVendasAnos}
                                            margin={{
                                                top: 15,
                                                right: 30,
                                                left: 30,
                                                bottom: 5
                                            }}
                                            barSize={40}
                                        >
                                            <XAxis dataKey="name" scale="point" padding={{ left: 50, right: 50 }} />
                                            <YAxis tickFormatter={tick => {
                                                return tick.toLocaleString();
                                            }} />
                                            <TooltipChart
                                                wrapperStyle={{
                                                    backgroundColor: "#22313a",
                                                    border: "1px solid #394e5a",
                                                }}
                                                itemStyle={{ color: Colors.primary }}
                                                labelStyle={{ color: Colors.primary }}
                                                formatter={value => new this.renderValor(value)}
                                            />
                                            <CartesianGrid strokeDasharray="3 3" />
                                            <Bar dataKey="vendas" fill="#8884d8" background={{ fill: "#eee" }} />
                                        </BarChart>
                                    </Row>
                                </div>
                            </Col>
                            <Col xs={24} md={12} style={{ height: 300, padding: 5 }}>
                                <div style={{ height: "100%", borderStyle: "outset", borderWidth: 2, borderRadius: 5, backgroundColor: "white" }}>
                                    <Row style={{ textAlign: "center", marginTop: 5, marginBottom: 5 }}>
                                        <span style={{ fontSize: 20, fontWeight: "bold", color: Colors.primary }}>
                                            Vendas - Ano {filtros.graficoVendasMeses}
                                        </span>
                                        <Tooltip title="Filtrar" placement="bottomLeft">
                                            <span onClick={() => this.onAbrirFiltroClick('GVM')} style={{ cursor: 'pointer', fontSize: 20, float: 'right', paddingRight: 20 }} >
                                                <Icon type="filter" />
                                            </span>
                                        </Tooltip>
                                    </Row>
                                    <Row>
                                        <BarChart
                                            width={window.innerWidth / 2.3}
                                            height={250}
                                            data={listaVendasMeses}
                                            margin={{
                                                top: 15,
                                                right: 30,
                                                left: 30,
                                                bottom: 5
                                            }}
                                            barSize={20}
                                        >
                                            <XAxis dataKey="name" scale="point" padding={{ left: 30, right: 30 }} />
                                            <YAxis tickFormatter={tick => {
                                                return tick.toLocaleString();
                                            }} />
                                            <TooltipChart
                                                wrapperStyle={{
                                                    backgroundColor: "#22313a",
                                                    border: "1px solid #394e5a",
                                                }}
                                                itemStyle={{ color: Colors.primary }}
                                                labelStyle={{ color: Colors.primary }}
                                                formatter={value => new this.renderValor(value)}
                                            />
                                            <CartesianGrid strokeDasharray="3 3" />
                                            <Bar dataKey="vendas" fill="#8884d8" background={{ fill: "#eee" }} />
                                        </BarChart>
                                    </Row>
                                </div>
                            </Col>
                        </Row>
                        <Row>
                            <Col xs={24} md={8} style={{ height: 300, padding: 5 }}>
                                <div style={{ height: "100%", borderStyle: "outset", borderWidth: 2, borderRadius: 5, backgroundColor: "white" }}>
                                    <Row style={{ textAlign: "center", marginTop: 5, marginBottom: 5 }}>
                                        <span style={{ fontSize: 20, fontWeight: "bold", color: Colors.primary }}>
                                            Metas / Ano
                                        </span>
                                    </Row>
                                    <Row >
                                        <BarChart
                                            width={window.innerWidth / 3.5}
                                            height={250}
                                            data={listaMetasAnos}
                                            margin={{
                                                top: 15,
                                                right: 30,
                                                left: 0,
                                                bottom: 5
                                            }}
                                            barSize={20}
                                        >
                                            <XAxis dataKey="name" scale="point" padding={{ left: 20, right: 20 }} />
                                            <YAxis tickFormatter={tick => {
                                                return tick.toLocaleString();
                                            }} />
                                            <TooltipChart
                                                wrapperStyle={{
                                                    backgroundColor: "#22313a",
                                                    border: "1px solid #394e5a",
                                                }}
                                                itemStyle={{ color: Colors.primary }}
                                                labelStyle={{ color: Colors.primary }}
                                                formatter={value => new this.renderValor(value)}
                                                label={'perc'}
                                            />
                                            <CartesianGrid strokeDasharray="3 3" />
                                            <Bar dataKey="meta" fill="#8884d8" />
                                            <Bar dataKey="vendas" fill="#82ca9d" />
                                            {/* <Bar dataKey="perc" fill="#82ca9d" /> */}
                                        </BarChart>
                                    </Row>
                                </div>
                            </Col>
                            <Col xs={24} md={8} style={{ height: 300, padding: 5 }}>
                                <div style={{ height: "100%", borderStyle: "outset", borderWidth: 2, borderRadius: 5, backgroundColor: "white" }}>
                                    <Row style={{ textAlign: "center", marginTop: 5, marginBottom: 5 }}>
                                        <span style={{ fontSize: 20, fontWeight: "bold", color: Colors.primary }}>
                                            Metas - Ano {filtros.graficoMetasMeses}
                                        </span>
                                        <Tooltip title="Filtrar" placement="bottomLeft">
                                            <span onClick={() => this.onAbrirFiltroClick('GMM')} style={{ cursor: 'pointer', fontSize: 20, float: 'right', paddingRight: 20 }} >
                                                <Icon type="filter" />
                                            </span>
                                        </Tooltip>
                                    </Row>
                                    <Row >
                                        <BarChart
                                            width={window.innerWidth / 3.5}
                                            height={250}
                                            data={listaMetasMeses}
                                            margin={{
                                                top: 15,
                                                right: 30,
                                                left: 0,
                                                bottom: 5
                                            }}
                                            barSize={15}
                                        >
                                            <XAxis dataKey="name" scale="point" padding={{ left: 20, right: 20 }} />
                                            <YAxis tickFormatter={tick => {
                                                return tick.toLocaleString();
                                            }} />
                                            <TooltipChart
                                                wrapperStyle={{
                                                    backgroundColor: "#22313a",
                                                    border: "1px solid #394e5a",
                                                }}
                                                itemStyle={{ color: Colors.primary }}
                                                labelStyle={{ color: Colors.primary }}
                                                formatter={value => new this.renderValor(value)}
                                            />
                                            <CartesianGrid strokeDasharray="3 3" />
                                            <Bar dataKey="meta" fill="#8884d8" />
                                            <Bar dataKey="vendas" fill="#82ca9d" />
                                            {/* <Bar dataKey="perc" fill="#82ca9d" /> */}
                                        </BarChart>
                                    </Row>
                                </div>
                            </Col>
                            <Col xs={24} md={4} style={{ height: 300, padding: 5 }}>
                                <div style={{ height: "100%", borderStyle: "outset", borderWidth: 2, borderRadius: 5, backgroundColor: "white" }}>
                                    <Row style={{ textAlign: "center", marginTop: 5, marginBottom: 5 }}>
                                        <Tooltip title={"Pedidos (Últimos 30 dias)"}>
                                            <span style={{ fontSize: 20, fontWeight: "bold", color: Colors.primary }}>
                                                Status Pedidos
                                            </span>
                                        </Tooltip>
                                    </Row>
                                    <Row>
                                        <PieChart width={window.innerWidth / 7.5} height={250}>
                                            <Pie
                                                dataKey="value"
                                                data={listaStatusPedidos}
                                                cx="50%"
                                                cy="50%"
                                                innerRadius={window.innerWidth / 65}
                                                outerRadius={window.innerWidth / 25}
                                                fill="#8884d8"
                                                label={renderCustomizedLabel}
                                                labelLine={false}
                                            >
                                                {listaStatusPedidos && listaStatusPedidos.map((entry, index) => (
                                                    <Cell key={`cell-${index}`} fill={CORES[index % CORES.length]} />
                                                ))}
                                            </Pie>
                                            {/* <TooltipChart
                                                formatter={value => new this.renderValor(value)}
                                            />
                                            <TooltipChart /> */}
                                            <TooltipChart isAnimationActive={true} />
                                            <Legend layout="horizontal" verticalAlign="top" align="center" />
                                        </PieChart>
                                    </Row>
                                </div>
                            </Col>
                            <Col xs={24} md={4} style={{ height: 300, padding: 5 }}>
                                <div style={{ height: "100%", borderStyle: "outset", borderWidth: 2, borderRadius: 5, backgroundColor: "white" }}>
                                    <Row style={{ textAlign: "center", marginTop: 5, marginBottom: 5 }}>
                                        <Tooltip title={"Período " + this.state.filtros.vendasCarteiraIni + ' a ' + this.state.filtros.vendasCarteiraFim}>
                                            <span style={{ fontSize: 20, fontWeight: "bold", color: Colors.primary }}>
                                                Carteira de Clientes
                                            </span>
                                        </Tooltip>
                                        <Tooltip title="Filtrar" placement="bottomLeft">
                                            <span onClick={() => this.onAbrirFiltroClick('GVC')} style={{ cursor: 'pointer', fontSize: 20, float: 'right', paddingRight: 20 }} >
                                                <Icon type="filter" />
                                            </span>
                                        </Tooltip>
                                    </Row>
                                    <Row>
                                        <PieChart width={window.innerWidth / 7.5} height={250}>
                                            <Pie
                                                dataKey="value"
                                                data={listaVendasCarteiraClientes}
                                                cx="50%"
                                                cy="50%"
                                                innerRadius={window.innerWidth / 65}
                                                outerRadius={window.innerWidth / 25}
                                                fill="#8884d8"
                                                label={renderCustomizedLabel}
                                                labelLine={false}
                                                startAngle={180}
                                                endAngle={-180}
                                            >
                                                {listaVendasCarteiraClientes && listaVendasCarteiraClientes.map((entry, index) => (
                                                    <Cell key={`cell-${index}`} fill={CORES[index % CORES.length]} />
                                                ))}
                                            </Pie>
                                            <TooltipChart isAnimationActive={true} />
                                            <Legend layout="horizontal" verticalAlign="top" align="center" />
                                        </PieChart>
                                    </Row>
                                </div>
                            </Col>
                        </Row>


                        <Row style={{ marginBottom: 20 }}>
                            <Col xs={24} md={8} style={{ height: 500, padding: 5 }}>
                                <div style={{ height: "100%", borderStyle: "outset", borderWidth: 2, borderRadius: 5, backgroundColor: "white" }}>
                                    <Row style={{ textAlign: "center", marginTop: 5, marginBottom: 5 }}>
                                        <span style={{ fontSize: 20, fontWeight: "bold", color: Colors.primary }}>
                                            Melhores Clientes
                                        </span>
                                        <Tooltip title="Filtrar" placement="bottomLeft">
                                            <span onClick={() => this.onAbrirFiltroClick('LMC')} style={{ cursor: 'pointer', fontSize: 20, float: 'right', paddingRight: 20 }} >
                                                <Icon type="filter" />
                                            </span>
                                        </Tooltip>
                                        <Row style={{ textAlign: 'right', paddingRight: 20 }}>{this.state.filtros.listaMelhoresClienteDataIni + ' a ' + this.state.filtros.listaMelhoresClienteDataFim}</Row>
                                    </Row>
                                    <Row style={{ maxHeight: 430, overflow: 'auto' }}>
                                        <Col xs={24} style={{ padding: 10, paddingLeft: 20 }}>
                                            <List
                                                className="demo-loadmore-list"
                                                itemLayout="horizontal"
                                                dataSource={listaClientes}
                                                renderItem={(item) => (
                                                    <List.Item
                                                    >
                                                        <List.Item.Meta
                                                            title={item.nome}
                                                        />
                                                        <div style={{ fontWeight: "bold", marginRight: 10 }}>{item.perc ? this.renderValor(item.perc.toFixed(2)) : '0,00'}%</div>
                                                        <div style={{ fontWeight: "bold" }}>R${item.valor ? this.renderValor(item.valor.toFixed(2)) : '0,00'}</div>
                                                    </List.Item>
                                                )}
                                            />
                                        </Col>
                                    </Row>
                                </div>
                            </Col>
                            <Col xs={24} md={8} style={{ height: 500, padding: 5 }}>
                                <div style={{ height: "100%", borderStyle: "outset", borderWidth: 2, borderRadius: 5, backgroundColor: "white" }}>
                                    <Row style={{ textAlign: "center", marginTop: 5, marginBottom: 5 }}>
                                        <span style={{ fontSize: 20, fontWeight: "bold", color: Colors.primary }}>
                                            Produtos mais Vendidos
                                        </span>
                                        <Tooltip title="Filtrar" placement="bottomLeft">
                                            <span onClick={() => this.onAbrirFiltroClick('LPV')} style={{ cursor: 'pointer', fontSize: 20, float: 'right', paddingRight: 20 }} >
                                                <Icon type="filter" />
                                            </span>
                                        </Tooltip>
                                        <Row style={{ textAlign: 'right', paddingRight: 20 }}>{this.state.filtros.listaProdutosVendidoDataIni + ' a ' + this.state.filtros.listaProdutosVendidoDataFim}</Row>
                                    </Row>
                                    <Row style={{ maxHeight: 430, overflow: 'auto' }}>
                                        <Col xs={24} style={{ padding: 10, paddingLeft: 20 }}>
                                            <List
                                                className="demo-loadmore-list"
                                                itemLayout="horizontal"
                                                dataSource={listaProdutos}
                                                renderItem={(item) => (
                                                    <List.Item>
                                                        <List.Item.Meta
                                                            title={item.nome}
                                                        />
                                                        <div style={{ fontWeight: "bold", marginRight: 10 }}>{item.perc ? this.renderValor(item.perc.toFixed(2)) : '0,00'}%</div>
                                                        <div style={{ fontWeight: "bold" }}>R${item.valor ? this.renderValor(item.valor.toFixed(2)) : '0,00'}</div>
                                                    </List.Item>
                                                )}
                                            />
                                        </Col>
                                    </Row>
                                </div>
                            </Col>
                            <Col xs={24} md={8} style={{ height: 500, padding: 5 }}>
                                <div style={{ height: "100%", borderStyle: "outset", borderWidth: 2, borderRadius: 5, backgroundColor: "white" }}>
                                    <Row style={{ textAlign: "center", marginTop: 5, marginBottom: 5 }}>
                                        <span style={{ fontSize: 20, fontWeight: "bold", color: Colors.primary }}>
                                            Vendas por Grupo
                                        </span>
                                        <Tooltip title="Filtrar" placement="bottomLeft">
                                            <span onClick={() => this.onAbrirFiltroClick('LGP')} style={{ cursor: 'pointer', fontSize: 20, float: 'right', paddingRight: 20 }} >
                                                <Icon type="filter" />
                                            </span>
                                        </Tooltip>
                                        <Row style={{ textAlign: 'right', paddingRight: 20 }}>{this.state.filtros.listaVendasGrupoDataIni + ' a ' + this.state.filtros.listaVendasGrupoDataFim}</Row>
                                    </Row>
                                    <Row style={{ maxHeight: 430, overflow: 'auto' }}>
                                        <Col xs={24} style={{ padding: 10, paddingLeft: 20 }}>
                                            <List
                                                className="demo-loadmore-list"
                                                itemLayout="horizontal"
                                                dataSource={listaGrupos}
                                                renderItem={(item) => (
                                                    <List.Item>
                                                        <List.Item.Meta
                                                            title={item.nome}
                                                        />
                                                        <div style={{ fontWeight: "bold", marginRight: 10 }}>{item.perc ? this.renderValor(item.perc.toFixed(2)) : '0,00'}%</div>
                                                        <div style={{ fontWeight: "bold" }}>R${item.valor ? this.renderValor(item.valor.toFixed(2)) : '0,00'}</div>
                                                    </List.Item>
                                                )}
                                            />
                                        </Col>
                                    </Row>
                                </div>
                            </Col>
                        </Row>
                    </Row>
                ) : (
                    <div style={{ align: 'center', textAlign: 'center' }}>
                        <img
                            alt="P7Vendas"
                            src={LogoP7Vendas}
                            style={{ height: 300, width: 300, marginTop: 100 }}
                        />
                    </div>
                )}
            </div >
        );
    }
}


// WEBPACK FOOTER //
// ./src/pages/HomePage.js